import React from 'react';

// Page shell: optional heading row above the white panel.
const AdminPage = ({ title, subtitle, headerActions, children }) => (
  <div className="ad-page">
    {(title || headerActions) && (
      <div className="ad-page-head">
        <div>
          {title && <h1 className="ad-page-title">{title}</h1>}
          {subtitle && <p className="ad-page-subtitle">{subtitle}</p>}
        </div>
        {headerActions}
      </div>
    )}
    <div className="ad-panel">{children}</div>
  </div>
);

export default AdminPage;
